import React from 'react';
import styled from 'styled-components';
import { FaLock } from 'react-icons/fa';
import { PasswordInput } from '../../../components/ui/Input/PasswordInput';
import { colors } from '../../../assets/styles/GlobalStyles';

const Section = styled.section`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e8ecef;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.8rem;
  border-bottom: 2px solid ${colors.lightBlue};
`;

const Icon = styled.div`
  color: ${colors.darkBlue};
  font-size: 1.2rem;
`;

const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${colors.darkBlue};
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.3rem;
`;

/**
 * Seção de senha e confirmação de senha do formulário de cadastro.
 * As regras de validação (mínimo 8 caracteres, confirmação igual à senha)
 * são definidas no validationRules do RegisterForm.
 */
export const PasswordSection = ({ values, errors, touched, onChange, onBlur }) => {
  return (
    <Section>
      <Header>
        <Icon><FaLock /></Icon>
        <div>
          <Title>Segurança</Title>
          <Description>Dados de acesso ao sistema</Description>
        </div>
      </Header>

      <PasswordInput
        label="Senha"
        name="password"
        value={values.password}
        onChange={onChange}
        onBlur={onBlur}
        error={touched.password && errors.password}
        required
        placeholder="Crie uma senha segura (mínimo 8 caracteres)"
        success={!errors.password && values.password?.length >= 8 && 'Senha válida'}
      />

      <PasswordInput
        label="Confirmar Senha"
        name="confirmPassword"
        value={values.confirmPassword}
        onChange={onChange}
        onBlur={onBlur}
        error={touched.confirmPassword && errors.confirmPassword}
        required
        placeholder="Digite a senha novamente"
        // só mostra o success quando o campo já tem valor, evitando "Senhas coincidem" com ambos vazios
        success={!errors.confirmPassword && values.confirmPassword &&
                 values.password === values.confirmPassword && 'Senhas coincidem'}
      />
    </Section>
  );
};
